var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 38,
    viewBox: "0 0 108 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5C1.61929 16.5 0.5 17.6193 0.5 19C0.5 20.3807 1.61929 21.5 3 21.5V16.5ZM106.768 20.7678C107.744 19.7915 107.744 18.2085 106.768 17.2322L90.8579 1.32233C89.8816 0.34602 88.2986 0.34602 87.3223 1.32233C86.346 2.29864 86.346 3.88155 87.3223 4.85786L101.464 19L87.3223 33.1421C86.346 34.1184 86.346 35.7014 87.3223 36.6777C88.2986 37.654 89.8816 37.654 90.8579 36.6777L106.768 20.7678ZM3 21.5H105V16.5H3V21.5Z",
    fill: "#C53EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMArrow);
export default __webpack_public_path__ + "static/media/m_arrow.145ca4e150b1a765bbc18b89c60b41c6.svg";
export { ForwardRef as ReactComponent };